const Protected = ({ isLoggedIn, children }) => {
  if (isLoggedIn) {
    return children;
  }
  return null;
};

export default Protected;
